import React from 'react'
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../i18';

const PaymentSuccessModal = ({ isOpen, isClose }) => {
    const { t } = useTranslation();
    if (!isOpen) return null;
    return (
        <>
            <div
                className="modal fade show modal-overlay"
                id="PaymentSuccessModal"
                style={{ display: 'block' }}
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="PaymentSuccessModalLabel">
                                {t('paymentSuccess')}
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={isClose}
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <p className="Modaltext">
                                {t('seeCourseInCourseMenu')}
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                onClick={isClose}
                                className="btn btn-border-black b-animate-3"
                            >
                                {t('close')}
                            </button>
                            <Link to={'/course'} className="btn btn-base b-animate-3">
                                {t('startCourses')}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PaymentSuccessModal;